export const PIXEL_ID = '1106774291706659';

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
